import { createAction } from 'redux-actions';

export const UPDATE_USER = 'USER::UPDATE';
export const RESET_USER = 'USER::RESET';

export const updateUser = createAction(UPDATE_USER);
export const resetUser = createAction(RESET_USER);
